<template>
  <div class="certificatePrintPool">
    <el-card>
      <el-form :inline="true" :model="filter" class="demo-form-inline" size="small">
        <el-form-item label="班级名称">
          <el-input v-model="filter.skuName" placeholder="请输入班级名称"></el-input>
        </el-form-item>
        <el-form-item label="用户手机号">
          <el-input v-model="filter.phone" placeholder="请输入用户手机号"></el-input>
        </el-form-item>
        <!-- <el-form-item label="审核状态">
          <el-select v-model="filter.auditState" placeholder="请选择审核状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="待审核" value="1"></el-option>
            <el-option label="已通过" value="2"></el-option>
            <el-option label="已驳回" value="3"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="套打状态">
          <el-select v-model="filter.printState" placeholder="请选择套打状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="未套打" value="1"></el-option>
            <el-option label="补打" value="2"></el-option>
            <el-option label="已套打" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="打印时间">
          <el-date-picker
            v-model="dateList"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" style="margin-left: 20px" @click="search">查询</el-button>
          <el-button type="" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px">
      <el-table :data="list" border>
        <el-table-column align="center" label="班级名称" prop="skuName" width=""></el-table-column>
        <el-table-column align="center" label="已绑定证书" prop="certificateNo" width=""></el-table-column>
        <el-table-column align="center" label="所属项目" prop="projectName" width=""></el-table-column>
        <el-table-column align="center" label="考场名称" prop="examTitle" width=""></el-table-column>
        <el-table-column align="center" label="用户昵称" prop="name" width=""></el-table-column>
        <el-table-column align="center" label="用户电话" prop="phone" width="">
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="handleViewPhone(row, $index)">{{ row.phone || '--' }}</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" label="合格证套打状态" prop="printState" width="">
          <template slot-scope="scope">
            <span v-if="scope.row.printState === 1">未套打</span>
            <span v-else-if="scope.row.printState === 2">补打</span>
            <span v-else-if="scope.row.printState === 3">已套打</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="套打申请审核状态" prop="" width="">
          <template slot-scope="scope">
            <span v-if="scope.row.auditState === 1">待审核</span>
            <span v-else-if="scope.row.auditState === 2">已通过</span>
            <span v-else-if="scope.row.auditState === 3">已驳回</span>
            <span v-else>--</span>
          </template>
        </el-table-column> -->
        <el-table-column align="center" label="证书打印人" prop="printUserName" width=""></el-table-column>
        <el-table-column align="center" label="打印时间" prop="printTime" width=""></el-table-column>
        <el-table-column align="center" label="操作" prop="" width="">
          <template slot-scope="scope">
            <a :disabled="!(applyNum > 0 && !scope.row.isOwn && scope.row.auditState == 2)" href="javascript:;" @click="$refs.print.init(scope.row.certificateNo, scope.row.id, 1)">套打合格证</a> <br />
            <a v-if="scope.row.printState === 2" href="javascript:;" @click="$refs.PrintMsg.init(scope.row)">查看补打说明</a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center;"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <PrintMsg ref="PrintMsg"/>
    <!-- //套打 -->
    <Print ref="print" />
  </div>
</template>

<script>
import { getPrintList,getPrintListByAgent } from "@/api/certificate/index";
import { getAppUserInfo } from "@/api/common";
import PrintMsg from '../components/PrintMsg.vue'
import Print from "../../class/classManage/components/com/print";
export default {
  name: 'CertificatePrintPool',
  components: { PrintMsg, Print },
  data () {
    return {
      filter: {
        page: 1,
        limit: 10,
        skuName: '',
        phone: '',
        auditState: 2,
        printState: '',
        printStartTime: '',
        printEndTime: ''
      },
      list: [],
      total: 0,
      applyNum: 0
    }
  },
  computed: {
    dateList: {
      get() {
        return [this.filter.printStartTime, this.filter.printEndTime]
      },
      set(v) {
        if (v && v.length) {
          this.filter.printStartTime = v[0] + ' 00:00:00' || ''
          this.filter.printEndTime = v[1] + ' 23:59:59' || ''
        } else {
          this.filter.printStartTime = ''
          this.filter.printEndTime = ''
        }
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      let res
      if (this.checkAdmin()) {
        res = await getPrintList(this.filter)
      } else {
        res = await getPrintListByAgent(this.filter)
      }
      this.list = res.data.records
      this.total = +res.data.total
      this.applyNum = res.data.current
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = ''
      })
      this.filter.auditState = 2
      this.filter.page = 1
      this.filter.limit = 10
      this.getList()
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    },
    handleViewPhone (row, index) {
      if (!/\*/.test(row.phone)) {
        return
      }
      getAppUserInfo({ userId: row.userId }).then(({ code, data: { phone } }) => {
        if (code === 0) {
          this.list.forEach((item, i) => {
            if (i === index) {
              item.phone = phone
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
